import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/Button.jsx';
import CategorySelect from '../../components/CategorySelect.jsx';
import { applyRowChoice, EXTRA_OPTION_GROUPS, RULE_NONE, valueOf } from './importCategoryRule.js';

/**
 * Decides one transaction on its own, for the rows no rule can: one (category, merchant) pair holding
 * things that belong in different places, like an Amazon "Garbage" that is trash bags once and a
 * diaper pail the next time.
 *
 * Closed, it is a link, since a picker on every row of a long table is a lot of controls for a choice
 * most rows never need. A row already in the ledger has nothing left to decide, and one with no id of
 * the export's has nothing an override could be keyed on.
 */
export default function ImportRowCategory({ row }) {
	const dispatch = useDispatch();
	const batch = useSelector((state) => state.importing.selectedBatch);
	const [open, setOpen] = useState(false);

	if(!batch || !row.external_id || row.status === 'duplicate') {
		return null;
	}

	if(!open) {
		return (
			<div className='import-row-override'>
				{!!row.override &&
				<span className='import-external-key'>Set for this transaction</span>
				}
				<Button flat small onClick={() => setOpen(true)}>
					{row.override ? 'Change' : 'Set for this one'}
				</Button>
			</div>
		);
	}

	return (
		<div className='import-row-override import-row-override-open'>
			<CategorySelect
				value={valueOf(row.override)}
				blank='Follow the rules'
				extraOptionGroups={EXTRA_OPTION_GROUPS}
				transactionName={row.merchant}
				/** The popup's scrolling body would clip the menu, so it renders into the page instead. */
				menuPortalTarget={typeof document === 'undefined' ? null : document.body}
				menuPlacement='auto'
				autoFocus
				openMenuOnFocus
				onChange={(option) => {
					setOpen(false);
					dispatch(applyRowChoice(batch.id, row.external_id, option ? option.value : RULE_NONE));
				}}
			/>
			<Button flat small onClick={() => setOpen(false)}>Cancel</Button>
		</div>
	);
}
